"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _synteticEvents = _interopRequireDefault(require("./synteticEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var JSXComponent =
/*#__PURE__*/
function () {
  function JSXComponent() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, JSXComponent);

    this.props = props;
    this.render = this.render.bind(this);
    this.ref = this.ref.bind(this, props);
  } // eslint-disable-next-line


  _createClass(JSXComponent, [{
    key: "ref",
    value: function ref(node, props) {
      var events = Object.keys(props).filter(function (prop) {
        return _synteticEvents.default.includes(prop);
      });
      events.forEach(function (synteticEvent) {
        var event = synteticEvent.replace(/^on/, '').toLowerCase();
        node.addEventListener(event, props[synteticEvent]);
      });
    } // eslint-disable-next-line

  }, {
    key: "render",
    value: function render() {}
  }]);

  return JSXComponent;
}();

var _default = JSXComponent;
exports.default = _default;